module.exports = __webpack_public_path__ + "resources/img/img_logo_clovergames_m_kr.c650dfa32d1c069b6c7db3462f1ab273.png";